Vue.component('ack-footer', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-footer',
	mounted() {
		appLog.log('ack-footer mounted');
	},
	props: {
		data: {
			type: Object,
			required: true,
		},
	},
	computed: {
		//...Vuex.mapGetters('navBar', ['switchMobileDropdowns']),
	},
	data() {
		return {};
	},
	methods: {
		//...Vuex.mapActions(['sayHi', 'someAction']),
		//...Vuex.mapActions('navBar', ['sayHi', 'closeAllMobileDropdowns']),

		isWebinarVideoPage() {
			let urlParams = new URLSearchParams(window.location.search);
			return urlParams.get('videoId') === 'DdAtAeuu4GQ';
		},
	},
	beforeDestroy() {},
	watch: {
		data: {
			handler() {},
			deep: false,
		},
	},
});
